import { useQuery } from '@tanstack/react-query';
import { http } from '@/network/http';

interface SupportUser {
  id: string;
  firstName: string;
  lastName: string;
  avatarUrl: string | null;
}

interface SupportContactsData {
  contactEmail: string;
  contactPhone: string;
  users: SupportUser[];
}

export function useSupportContacts() {
  return useQuery<SupportContactsData>({
    queryKey: ['support-contacts'],
    queryFn: async () => {
      const { data } = await http.get('/settings/support-contacts');
      return data;
    },
  });
}
